import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import classnames from 'classnames';
import Text from 'src/components/Text';
import { Avatar } from '@mui/material';
import { PRIMARY_PAYMENT_LIGHT } from 'src/global/theme/colors';
import GenericActionButton from 'src/components/GenericActionButton';
import { IHeaderLayout } from '@interfaces/layout';
import goBack from 'src/global/assets/icons/full-arrow-left.svg';
import { getInitialFromFullName } from 'src/utils/global';
import Icon from 'src/components/Icon';

import { styles } from './styles';

const HeaderLayout = ({
  title,
  titleVariant = 'Amount-Medium',
  secondTitle,
  subTitle,
  hasTabMenu,
  iconTitle,
  hasBackground = true,
  labelButton,
  iconButton,
  withProfileAvatar,
  hasButtonGoBack,
  routeGoBack,
  handleOnClick,
  actionButton
}: IHeaderLayout) => {
  const { classes } = styles();
  const navigate = useNavigate();

  const { classNameAvatar, initials = '' } = withProfileAvatar || {};

  const initialsName = useMemo(() => getInitialFromFullName(initials), [initials]);

  const handleGoBack = () => {
    routeGoBack ? navigate(routeGoBack) : navigate(-1);
  };
  return (
    <div className={classnames(classes.headerContainer, { [classes.hasBackground]: hasBackground })}>
      {hasButtonGoBack && (
        <div className={classes.goBackContainer}>
          <button type="button" aria-label={'go-back'} onClick={handleGoBack} className={classes.iconContainer}>
            <Icon source={goBack} className={classes.icon} alt={'Ícono Buscar'} />
            <Text variant="H3-Medium" color={PRIMARY_PAYMENT_LIGHT}>
              Volver
            </Text>
          </button>
        </div>
      )}
      <div
        className={classnames(classes.titleAndButtonContainer, {
          [classes.extraSpaceBottom]: hasTabMenu
        })}>
        <div className={classes.textContainer}>
          {title && <Text variant={titleVariant}>{title}</Text>}
          {secondTitle && (
            <Text className={classes.secondTitle} color={PRIMARY_PAYMENT_LIGHT} variant={titleVariant}>
              {secondTitle}
            </Text>
          )}
          {iconTitle && <img className={classes.iconTitle} src={iconTitle} alt="" />}
        </div>

        {labelButton && (
          <div>
            <GenericActionButton
              startIcon={<Icon source={iconButton} alt={'Icono Mas'} />}
              label={labelButton}
              onClick={handleOnClick}
            />
          </div>
        )}

        {withProfileAvatar && (
          <Avatar className={classnames(classes.avatar, classNameAvatar)}>{initialsName}</Avatar>
        )}

        <div className={classes.downloadButton}>
          {actionButton}
        </div>
      </div>
      {subTitle && (
        <div className={classes.subTitle}>
          <Text variant="Callout-Regular">{subTitle}</Text>
        </div>
      )}
      {hasTabMenu && <div className={classes.tabMenu}>{hasTabMenu}</div>}
    </div>
  );
};

export default HeaderLayout;
